// extracted by mini-css-extract-plugin
export default {"rect":"skeleton_rect__hx4Cz","wave":"skeleton_wave__xrW7B","text":"skeleton_text__NHyo7"};